import FeaturesPage from 'components/Features/FeaturesPage/FeaturesPage'

export default FeaturesPage
